import { render, staticRenderFns } from "./PetaTenant.vue?vue&type=template&id=044b6d56&scoped=true"
import script from "./PetaTenant.vue?vue&type=script&lang=js"
export * from "./PetaTenant.vue?vue&type=script&lang=js"
import style0 from "./PetaTenant.vue?vue&type=style&index=0&id=044b6d56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044b6d56",
  null
  
)

export default component.exports